import { MenuItemGroup, MenuItemLookupResult, PortionItemType, RecentOrFavoriteEntree, RecentOrFavoriteOrder } from '@/models';

export function joinWithSuffixOfMoreEntreeContents(items: string[], maxChars: number): string {
  return joinItemsWithSuffix(
    items.map(item => ({ name: item, quantity: 1 })),
    maxChars,
    false,
  );
}

export function joinItemsWithSuffix(items: { name: string; quantity: number }[], maxChars: number, displayQuantity: boolean): string {
  const separator = ', ';
  const separatorLength = separator.length;

  const { remainingItems, shownItems } = items.reduce(
    (acc, item) => {
      const formattedItem = displayQuantity ? `${item.quantity} ${item.name}` : item.name;

      if (formattedItem.length + acc.length > maxChars) {
        acc.remainingItems += item.quantity;
      } else {
        acc.shownItems.push(formattedItem);
        acc.length += formattedItem.length + separatorLength;
      }

      return acc;
    },
    {
      shownItems: [] as string[],
      remainingItems: 0,
      length: 0,
    },
  );

  const formattedItems = [...shownItems].join(', ');

  if (remainingItems) {
    return `${formattedItems}${shownItems.length == 1 ? '' : ','} and ${remainingItems} more item${remainingItems === 1 ? '' : 's'}.`;
  }

  return formattedItems;
}

export function formatEntreeContents(entree: RecentOrFavoriteEntree, menuItemLookupMap: Map<string, MenuItemLookupResult> | null): string[] {
  return (entree.contents || []).map(content => {
    const contentLookupItem = menuItemLookupMap ? menuItemLookupMap.get(content.menuItemId) : null;
    const entreeLookupItem = menuItemLookupMap ? menuItemLookupMap.get(entree.menuItemId) : null;

    if (!entreeLookupItem || !contentLookupItem) {
      return content.menuItemName;
    }

    switch (contentLookupItem.menuItemType) {
      case PortionItemType.HalfPortion:
        return `½ ${entreeLookupItem.primaryFillingName}, ${content.menuItemName.replace('Half', '½')}`;
      case PortionItemType.ExtraPortion:
        const extraFillingName = content.menuItemName.replace('Extra ', '');
        const primaryFillingName = entreeLookupItem.primaryFillingName;
        if (extraFillingName === primaryFillingName) {
          return `2x ${primaryFillingName}`;
        }
        return `1x ${primaryFillingName}, 1x ${extraFillingName}`;
      default:
        return content.menuItemName;
    }
  });
}
